// extracted by mini-css-extract-plugin
export default {"cardTitle":"cardTitle___y9Bmb","cardContent":"cardContent___HoUB9"};